import { createAction } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";

import { KnowYourCustomerUrlResponse, KycMessage } from "./kyc-verification.model";

const ACTION_PREFIX = "[Kyc Verification]";

export namespace KycVerificationAction {
	export const getKnowYourCustomerUrl = createAction(`${ACTION_PREFIX} Get Know Your Customer Url`);

	export const getKnowYourCustomerUrlSuccess = createAction(
		`${ACTION_PREFIX} Get Know Your Customer Url Success`,
		(knowYourCustomerUrl: KnowYourCustomerUrlResponse) => ({ uri: knowYourCustomerUrl.uri })
	);

	export const getKnowYourCustomerUrlFail = createAction(
		`${ACTION_PREFIX} Get Know Your Customer Url Fail`,
		(error: AppError | Error) => ({ error })
	);

	export const checkKycMessage = createAction(`${ACTION_PREFIX} Check KYC Message`, (payload: KycMessage) => ({
		payload,
	}));

	export const getIframeHeight = createAction(`${ACTION_PREFIX} Get Iframe Height`, (height: number | undefined) => ({
		payload: height,
	}));

	export const closeIframe = createAction(`${ACTION_PREFIX} Close Iframe`);
}
